import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { spineLoader } from '@play-co/timestep-spine';
import { downscale } from 'src/conf/scale';
import { HeaderCrocodile } from '../components/HeaderCrocodile';

const folder = 'assets/minigame/rescueLevel/theme-crocodile';

const assetMap = {
  iconSmall: `${folder}/icon_small.png`,
  iconLarge: `${folder}/icon_large.png`,
  dream: `${folder}/dream.png`,
  background: `${folder}/background.png`,
  header: {
    loadMethod: spineLoader,
    url: `${folder}/animation/spine.rescue_crocs`,
  },
};

export const rescueLevelThemeCrocodile = {
  getHeader: (opts: ViewOpts) => new HeaderCrocodile(opts),
  getAssets: () => Object.values(assetMap),
  getDream: (opts: ViewOpts) => {
    return new ImageScaleView({
      image: assetMap.dream,
      width: downscale(231),
      height: downscale(155),
      offsetX: -downscale(231) / 2,
      offsetY: -downscale(155) / 2 - 10,
      ...opts,
    });
  },
  getIconLarge: (opts: ViewOpts) => {
    return new ImageScaleView({
      image: assetMap.iconLarge,
      width: downscale(589),
      height: downscale(461),
      centerOnOrigin: true,
      ...opts,
    });
  },
  getIconSmall: (opts: ViewOpts) => {
    return new ImageScaleView({
      image: assetMap.iconSmall,
      width: downscale(178),
      height: downscale(139),
      centerOnOrigin: true,
      ...opts,
    });
  },
  getHeaderBackground: () => assetMap.background,
  getHeaderSpine: () => assetMap.header.url,
};
